import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import "./productActionHeader.style.scss";
import { FormattedMessage } from "react-intl";
import { useGlobalState } from "../../context/Provider";

import {
  MinusSquareTwoTone,
  PlusCircleTwoTone,
  TransactionOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

const handleBack = () => {
  window.history.back();
};

const ProductActionHeader: FC = () => {
  const { langState }: any = useGlobalState();
  const lang = langState.locale;
  const { type }: any = useParams();

  return (
    <div className="header-action">
      <Button onClick={handleBack}>
        {lang === "en-US" ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}

        <FormattedMessage id="productActionHeader.backToList" />
      </Button>

      <div>
        {type === "towarehouse" ? (
          <PlusCircleTwoTone style={{ fontSize: 35 }} twoToneColor="#00C897" />
        ) : type === "exit" ? (
          <MinusSquareTwoTone style={{ fontSize: 35 }} twoToneColor="#D82148" />
        ) : type === "transfer" ? (
          <TransactionOutlined style={{ fontSize: "35px", color: "#1890ff" }} />
        ) : null}
      </div>
      <div></div>
    </div>
  );
};

export default ProductActionHeader;
